import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import {
  AuthService,
  isDefined,
  isDefinedNotNull,
  isUndefinedOrNull,
  isUndefinedOrNullOrEmpty,
  PowerSupplyListService,
  PowerSupplyService,
  PSConfigService
} from '@psnb/services';
import { Router, ActivatedRoute } from '@angular/router';
import { DefaultService, PowerSupply, PowerSupplyAlertsRequest, PowerSupplySeverityAlertResponse } from '@psnb/psnb-api';
import { JsonAdvancedSearchResult, NodeServiceResourceService } from '@psnb/nwt-api';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataService } from './data.service';
import { environment } from './../../../environments/environment';
import { MsalService } from '@azure/msal-angular';
import { UserDetails } from "@psnb/psnb-api";
import { CommonService } from '../../common/common.service';
@Component({
  selector: 'nwt-power-supply-list',
  templateUrl: './power-supply-list.component.html',
  styleUrls: ['./power-supply-list.component.scss']
})

export class PowerSupplyListComponent implements OnInit, OnDestroy {
  public showCount: boolean = false;
  public showProgressBarLoad: boolean = false;
  public userDetails: UserDetails;

  rowData: any = [];
  powerSupplyAlertsRequest: PowerSupplyAlertsRequest;
  isAdmin: boolean = false;
  showProgressBar: boolean = false;
  showLoading: boolean = false;
  showEditProgressBar: boolean = false;
  lastvisitValidations: FormGroup;
  //visitTypes: string[] = ['', 'Annual Inspection', 'Maintenance', 'Repair', 'Outage', 'Nitro'];
  visitTypes: string[] = [];
  visitTypesbp: string[] = [];
  params = {
    address: null,
    nodeCommunintyServed: null,
    headendOrCommunity: null,
    latitude: null,
    longitude: null,
    distance: null,
    macAddress: null,
    node: null,
    nodeId: null,
    nodeName: null,
    powerSupplyName: null,
    regionId: null,
    type: null,
    powerSupplyId:null,
    nodeText: null,
  };
  editTitle: any;
  macAddress: any;
  psAlertsList: any;
  alertanimated: any;
  alertColor: any;
  nodeValue: any;
  disableVal: any;
  colorFlag: boolean = false;
  pslogdate: any;
  powerSupplyId: any;
  triageId: any;
  userName: string = '';
  loguserName: any;
  distance: any;
  logDate: any;
  mainarr: any = [];
  permissionValue: any;
  userGrouppermissionValue: any;
  userpermissions: any;
  alertsEventsTopNavModuleTab: any;
  //visitTypesinhouse: any[] = [];
  //visitTypesbp: any[] = [];
  detailsIconEnable:any;
  editIconEnable:any;
  alertsEnable:any;
  telemetryEnable:any;

  private lastVisitDate: string | undefined;

  private readonly destroyed$: Subject<void> = new Subject<void>();
  public constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private data: DataService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private msalService: MsalService,
    private nodeServiceResourceService: NodeServiceResourceService,
    private powerSupplyListService: PowerSupplyListService,
    private powerSupplyService: PowerSupplyService,
    private psnbApi: DefaultService,
    private psConfigService: PSConfigService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.powerSupplyAlertsRequest = {};
  }

  /*Function to open the last visit dialog -  Popup open */
  macAdd;
  logName;
  triage;
  openmaintainanceDialog(powerSupplyId, macAddress, templateRef: TemplateRef<any>, templateRefValid: TemplateRef<any>) {

    this.userDetails = JSON.parse(localStorage['user-details']);
    if (this.userDetails.permissions.includes('{1091}')) {
      this.permissionValue = true;
    } else {
      this.permissionValue = false;
    }
    // if (!this.msalService.getAccount().name.includes(environment.BPUserKeyword)) {
    if (this.permissionValue) {
      this.showEditProgressBar = true;
      this.dialog.open(templateRef);
      this.macAdd = macAddress;
    } else {
      this.showLoading = true;
      this.powerSupplyService.getPowerSupplyByPsId(powerSupplyId)
        .subscribe(data => {
          if (data.logName != null && data.powerSupplyId != null) {
            //if triage record is there have to check the 24 hrs and same users and load the triage data in ps edit page
            this.loguserName = data.logNt.toUpperCase();
            var currentDate = new Date().getTime() + (1 * 24 * 60 * 60)
            this.pslogdate = data.logDate;
            this.userName = this.authService.getUserDetails.userName.toUpperCase();
            var currdate = new Date(new Date(currentDate).toLocaleString());
            var pslogdate = new Date(new Date(this.pslogdate).toLocaleString());
            var currdatebefore = new Date();
            currdatebefore.setDate(currdate.getDate() - 1);
            if (currdatebefore > pslogdate && this.userName == this.loguserName) {
              this.dialog.open(templateRefValid);
              this.macAdd = macAddress;
              this.logName = data.logName;
              this.triage = false;
            } else if (this.userName != this.loguserName) {
              this.showEditProgressBar = true;
              this.dialog.open(templateRefValid);
              this.macAdd = macAddress;
              this.logName = data.logName;
              this.triage = false;
            } else {
              this.showEditProgressBar = true;
              this.dialog.open(templateRef);
              this.macAdd = macAddress;
              this.triage = true;
              this.triageId = data.triageId;
            }
          } else {
            //no triage record is there have to open the edit ps normal flow
            this.showEditProgressBar = true;
            this.dialog.open(templateRef);
            this.macAdd = macAddress;
          }
          this.showLoading = false;
        });
    }

  }

  /*Function to close the last visit dialog -  Popup close */
  closeeditpseDialog(templateRef: TemplateRef<any>) {
    this.lastvisitValidations.reset();
    this.dialog.closeAll();
  }

  /*Function to open the last visit dialog -  Popup open */
  visittp;
  editPS(visittype) {
    this.dialog.closeAll();
    this.visittp = visittype;
    if (this.triage) {
      this.router.navigate(['/edit'], { queryParams: { macAddress: this.macAdd, triageId: this.triageId } });
    } else {
      this.router.navigate(['/edit'], { queryParams: { macAddress: this.macAdd } });
    }
    this.data.changeMessage(this.visittp);
  }

  /*Function to open the last visit dialog user select ok button -  Popup open */
  validationOk(templateRef) {
    this.dialog.closeAll();
    this.dialog.open(templateRef);
  }

  /*Function to cancel the last visit dialog user select cancel button -  Popup close */
  cancelOk() {
    this.dialog.closeAll();
    this.showLoading = false;
  }

  ngOnInit() {
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
    //this.userpermissions = this.authService.getDecryptConfig

    if (this.userpermissions=='' || !this.authService.isAuthorizedPSNBUser) {
      this.router.navigate(['/unauthorized']);
    }
    /*Validation for last visit dialog */
    this.lastvisitValidations = this.fb.group({
      visittype: ['', [Validators.required]]
    });

    /*Function to get the Power Supply Search data - Search based */
    this.route.queryParams
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.params.node = params['node'];
        this.params.nodeCommunintyServed = params['nodeCommunintyServed'];
        this.params.headendOrCommunity = params['headendOrCommunity'];
        this.params.latitude = params['latitude'];
        this.params.longitude = params['longitude'];
        this.params.macAddress = params['macAddress'];
        this.params.powerSupplyId = params['powerSupplyId'];
        this.params.address = params['address'];
        this.params.powerSupplyName = params['powerSupplyName'];
        this.params.nodeId = params['nodeId'];
        this.params.nodeName = params['nodeName'];
        this.params.regionId = params['regionId'];
        this.params.type = params['type'];
        this.macAddress = params['macAddress'];
        this.params.nodeText = params.nodeText;
        this.params.distance = 2;
        this.showProgressBarLoad = true;
        this.showCount = false;
        if (this.params.nodeText) {
          this.nodeServiceResourceService.resourceNodeServiceResourceAdvancedSearchGET(this.params.nodeText)
            .pipe(
              switchMap((advancedSearchResults: JsonAdvancedSearchResult[]): Observable<PowerSupply[]> => {
                if (isUndefinedOrNullOrEmpty(advancedSearchResults)) {
                  throw new Error('No data found.');
                }
                if (advancedSearchResults.length === 1) {
                  const { node, nodeCommunintyServed, nodeId } = advancedSearchResults[0];
                  Object.assign(this.params, { node, nodeCommunintyServed, nodeId });
                }
                return this.powerSupplyListService.getPowerSupplyList(this.params);
              }),
              take(1),
              takeUntil(this.destroyed$)
            )
            .subscribe({
              error: (): void => {
                this.rowData = [];
                this.distance = undefined;
                this.logDate = undefined;
                this.lastVisitDate = undefined;
                this.nodeValue = undefined;
                this.showProgressBarLoad = false;
                this.showCount = true;
              },
              next: (resultdata: PowerSupply[]): void => this.handlePowerSupplyListSuccess(resultdata)
            });
        } else {
          //List page data
          this.powerSupplyListService.getPowerSupplyList(this.params)
            .pipe(take(1), takeUntil(this.destroyed$))
            .subscribe((resultdata: PowerSupply[]): void => this.handlePowerSupplyListSuccess(resultdata));
        }
      });

    this.userDetails = JSON.parse(localStorage['user-details']);
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
    //this.userpermissions = this.authService.getDecryptConfig
    for (let element of this.userpermissions) {
      //Alerts/Events Tab Top Nav Module functionality
      if (element.category === CommonService.ALERTSEVENTS && element.functionality === CommonService.ALERTSEVENTS) {
        this.alertsEventsTopNavModuleTab = this.commonService.permissionlevel(element.permission);
      }
      if (element.category === CommonService.DETAILSICONCAT && element.functionality === CommonService.DETAILSICON) {
        this.detailsIconEnable = this.commonService.permissionlevel(element.permission);
      }
      if (element.category === CommonService.EDITICONCAT && element.functionality === CommonService.EDITICON) {
        this.editIconEnable = this.commonService.permissionlevel(element.permission);
      }
      if (element.category === CommonService.ALERTICONCAT && element.functionality === CommonService.ALERTICON) {
        this.alertsEnable = this.commonService.permissionlevel(element.permission);
      }
      if (element.category === CommonService.TELEMETRYICONCAT && element.functionality === CommonService.TELEMETRYICON) {
        this.telemetryEnable = this.commonService.permissionlevel(element.permission);
      }
    }
    this.psConfigService.getAllPsEditFieldsMetadata().subscribe((res) => {
      res.forEach((itemData, index) => {
        if (itemData['fieldName'] == 'Type of Visit - Inhouse') {
          this.visitTypes.push(itemData['value']);
          this.visitTypes.sort();
        } else if (itemData['fieldName'] == 'Type of Visit - BP') {
          this.visitTypesbp.push(itemData['value'])
          this.visitTypesbp.sort();
        }
      });
    });


  }

  public ngOnDestroy(): void {
    this.dialog?.closeAll();
    this.destroyed$?.next();
    this.destroyed$?.complete();
  }

  /*Function to get the detailed view Power Supply - Button Click */
  detailsPS(powerSupplyId) {
    this.router.navigate(['/details'], { queryParams: { powerSupplyId: powerSupplyId } });
  }

  telemetryUrl(powerSupplyId) {
    var domain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    const url = domain + `/#/telemetry?powerSupplyId=${powerSupplyId}`;
    window.location.href = url;
  }

  alertUrl(powerSupplyId, macAddress, psname) {
    var domain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    const url = domain + `/#/alerts?powerSupplyId=${powerSupplyId}`;
    window.location.href = url;
  }

  disableEdit(nodeName) {
    if (nodeName === '' || nodeName === null || nodeName === undefined) {
      this.editTitle = 'Nodeid is incorrect.';
      this.disableVal = false;
      return true;
    } else {
      this.editTitle = 'Edit PS';
      this.disableVal = true;
      return false;
    }
  }

  private handlePowerSupplyListSuccess(resultdata: PowerSupply[]): void {
    if (isDefined(this.params.latitude) && isDefined(this.params.longitude)) {
      this.distance = true;
    }
    this.rowData = resultdata;
    if (!isUndefinedOrNullOrEmpty(resultdata)) {
      this.lastVisitDate = this.rowData[0].logDate;
      this.logDate = new Date(this.lastVisitDate).toLocaleString();
      this.nodeValue = resultdata[0].nodeName;
      this.disableEdit(this.nodeValue);
      this.showProgressBarLoad = false;
      this.showCount = true;
      const macArray: string[] = [];
      for (const supply of resultdata) {
        if (!isUndefinedOrNull(supply.gpsLatitude)) {
          const gpslat: number = this.commonService.decimalCount(supply.gpsLatitude);
          supply.gpsLatitude = gpslat > 6 ? supply.gpsLatitude : Number(supply.gpsLatitude.toFixed(6));
        }
        if (!isUndefinedOrNull(supply.gpsLongitude)) {
          const gpslong: number = this.commonService.decimalCount(supply.gpsLongitude);
          supply.gpsLongitude = gpslong > 6 ? supply.gpsLongitude : Number(supply.gpsLongitude.toFixed(6));
        }
        this.macAddress = supply.macAddress?.toUpperCase() ?? '';
        macArray.push(this.macAddress);
      }
      this.psnbApi.getAlertsSeverityLevel(macArray)
        .pipe(take(1), takeUntil(this.destroyed$))
        .subscribe((result: PowerSupplySeverityAlertResponse): void => {
          for (const supply of this.rowData) {
            for (const alert of result.psAlertsSeverityList ?? []) {
              if (isDefinedNotNull(supply.macAddress) &&
                  isDefinedNotNull(alert.macAddress) &&
                  supply.macAddress.toUpperCase() === alert.macAddress?.toUpperCase()) {
                supply.hasMajor = alert.hasMajor;
              }
            }
          }
        });
    } else {
      this.showProgressBarLoad = false;
      this.showCount = true;
    }
  }

  //Check the admin previlages
  getAdmin(): boolean {
    return this.isAdmin;
  }
}
